import store from '@/common/vuex';
import { constantsRouters } from '@/common/router';

export const sidebarHighlight = path => {
    let result = {};
    /** 递归函数
     * @param {Array} routeList 路由列表
     * @param {String} path 当前路由地址
     * @param {String} pid 父路由id
     * @returns
     */
    const fn = (router, path, pids = []) => {
        for (let i = 0; i < router.length; i++) {
            const item = router[i];
            if (item.pid && item.pid !== '0' && pids.indexOf(item.pid) < 0) {
                pids = [...pids, item.pid];
            }
            if (item.path === path) {
                result = {
                    openKeys: pids,
                    selectedKey: item.id
                };
            } else if (item.children && item.children.length > 0) {
                fn(item.children, path, pids);
            }
        }
    };
    const permissionRouters = store.getters.permissionRouters || [];
    fn(constantsRouters.concat(permissionRouters), path, []);
    return result;
};
